<div class="testimonial-section">
  <div class="testimonial-content">
    <div class="testimonial-slider">
      <div class="testimonial-fade" [class.fade-out]="!isVisible">
        <div class="testimonial-text">
          <p>{{ currentTestimonial.text }}</p>
          <div class="testimonial-author">
            <img
              [src]="currentTestimonial.author.avatar"
              [alt]="currentTestimonial.author.name"
              class="author-avatar"
            />
            <div class="author-info">
              <div class="author-name">{{ currentTestimonial.author.name }}</div>
              <div class="author-title">{{ currentTestimonial.author.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="brands-section">
      <h6>Join leading brands to grow beyond barriers</h6>
      <div class="brand-logos">
        <div class="brand-logo-placeholder">
          <img
            src="https://storage.googleapis.com/pg-staging-static-files/testimonies/logo/janji-jiwa.svg"
            alt="logo-portaner"
          />
        </div>
        <div class="brand-logo-placeholder">
          <img
            src="https://storage.googleapis.com/pg-staging-static-files/testimonies/logo/paper.svg"
            alt="logo-portaner"
          />
        </div>
        <div class="brand-logo-placeholder">
          <img
            src="https://storage.googleapis.com/pg-staging-static-files/testimonies/logo/easylink.svg"
            alt="logo-portaner"
          />
        </div>
        <div class="brand-logo-placeholder">
          <img
            src="https://storage.googleapis.com/pg-staging-static-files/testimonies/logo/eats.svg"
            alt="logo-portaner"
          />
        </div>
        <div class="brand-logo-placeholder">
          <img
            src="https://storage.googleapis.com/pg-staging-static-files/testimonies/logo/ids.svg"
            alt="logo-portaner"
          />
        </div>
        <div class="brand-logo-placeholder">
          <img
            src="https://storage.googleapis.com/pg-staging-static-files/testimonies/logo/mobi.svg"
            alt="logo-portaner"
          />
        </div>
        <div class="brand-logo-placeholder">
          <img
            src="https://storage.googleapis.com/pg-staging-static-files/testimonies/logo/atoer.svg"
            alt="logo-portaner"
          />
        </div>
      </div>
    </div>
  </div>
</div>
